import type { CoverageStatus, CoverageValue } from '../components/Coverage/Coverage';

const MIN_MET_PERCENTAGE = 90;
const MAX_MET_PERCENTAGE = 110;

export const classifyCoverage = (percentage: number): CoverageStatus => {
	if (percentage === 100) return 'complete';
	if (percentage >= MIN_MET_PERCENTAGE && percentage <= MAX_MET_PERCENTAGE) return 'met';
	return percentage < MIN_MET_PERCENTAGE ? 'below' : 'above';
};

export const toCoverage = (supplied: number | null, demand: number | null): CoverageValue | null => {
	if (supplied == null || demand == null || !Number.isFinite(demand) || demand <= 0) return null;
	const percentage = Math.round((supplied / demand) * 100);
	return { percentage, status: classifyCoverage(percentage) };
};
